import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100/50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-2 mb-2">
            <div className="w-1 h-5 rounded-full bg-accent-500"></div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
              影视分类
            </h2>
          </div>
          <p className="text-sm text-foreground-500">选择您感兴趣的分类，发现更多精彩内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className="group relative bg-background-100 rounded-xl p-6 md:p-7 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-24 h-24 bg-primary-500/5 rounded-bl-full group-hover:bg-primary-500/10 transition-colors duration-300"></div>
              <div className="relative z-10">
                <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                  <i className={`${cat.icon} text-xl text-primary-400`}></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-100 mb-2 group-hover:text-primary-400 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                  {cat.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-foreground-600">
                    <strong className="text-accent-400 font-semibold">
                      {cat.count.toLocaleString()}
                    </strong>{' '}
                    部资源
                  </span>
                  <span className="flex items-center gap-1 text-xs text-primary-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    进入分类
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}